import {actions, useAppDispatch} from '@lib/store';
import {useEffect} from 'react';
import {Outlet} from 'react-router';
import {GROUP_DATA_DATE_RANGE} from '@lib/store/src/data/groups/constants';
import {ConnectionsProvider} from './ConnectionsContext/ConnectionsContext';

type Props = {};

export const ConnectionsOutlet = (props: Props) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(actions.loadShowWeekends());
  }, [dispatch]);

  return (
    <ConnectionsProvider dataDateRange={GROUP_DATA_DATE_RANGE}>
      <Outlet />
    </ConnectionsProvider>
  );
};
